module.exports = __webpack_public_path__ + "static/WEDDING E&M-509-10a305123ae880db2dc2450a46526caf.jpg";